export default {
    AUDITIVA: 1,
    VISUAL: 2,
    INTELECTUAL_CONGNITIVA: 3,
    FISICA: 4,
    OUTRA: 5,
    TEA: 6,
}